module.exports = __webpack_public_path__ + "img/ironing.b9fe9ff7.jpg";